import React from "react";
import Grid from "@mui/material/Grid2";
import { Grid2Props, SxProps, Theme } from "@mui/material";
import { useTheme } from "@mui/material/styles";

type WithGrowType = {
  fixed: React.ReactNode;
  direction?: Grid2Props["direction"];
  className?: string;
  sx?: SxProps<Theme>;
  fixedSx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
  height?: string;
  bottomfixed?: React.ReactNode;
};

const resolveSx = (sx: SxProps<Theme> | undefined, theme: Theme) =>
  typeof sx === "function" ? sx(theme) : sx;

export const WithGrow = ({
  ref,
  ...props
}: React.PropsWithChildren<WithGrowType> & {
  ref?: React.Ref<HTMLDivElement>;
}) => {
  const {
    fixed,
    children,
    fixedSx,
    containerSx,
    sx,
    height = "100%",
    bottomfixed,
    ...other
  } = props;

  const theme = useTheme();
  const rootStyles = resolveSx(sx, theme);
  const fixedStyles = resolveSx(fixedSx, theme);
  const contentStyles = resolveSx(containerSx, theme);

  return (
    <Grid
      ref={ref}
      container
      wrap="nowrap"
      {...other}
      sx={[
        {
          width: "100%",
          height,
        },
        ...(Array.isArray(rootStyles) ? rootStyles : [rootStyles]),
      ]}
    >
      <Grid
        sx={{
          flexShrink: 0,
          ...fixedStyles,
        }}
      >
        {fixed}
      </Grid>
      <Grid
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          minWidth: 0,
          overflow: "hidden",
          ...contentStyles,
        }}
      >
        {children}
      </Grid>

      <Grid sx={{ flexShrink: 0 }}>{bottomfixed}</Grid>
    </Grid>
  );
};
WithGrow.displayName = "WithGrow";
